import { createElement } from "react";

import type { ElementType, PropsWithChildren } from "react";

const ICON_PROPS = {
  size: 32,
  weight: "light",
  className: "opacity-50",
} as const;

const ICON_PROPS_COMPACT = {
  size: 24,
  weight: "regular",
  className: "opacity-50",
} as const;

const _ROW =
  "w-full flex flex-row gap-2 text-left [&:not(:first-child)]:border-t border-dashed";
const ROW_STYLE = _ROW + " p-3";
const ROW_STYLE_COMPACT = _ROW + " px-1 py-2";

export function LineItem(
  props: PropsWithChildren<{
    as?: ElementType;
    compact?: boolean;
    highlight?: boolean;
    Icon: ElementType;
    [key: string]: unknown;
  }>,
) {
  const {
    as = "div",
    children,
    compact = false,
    Icon,
    highlight = false,
    ...rest
  } = props;

  return createElement(
    as,
    {
      className: `${compact ? ROW_STYLE_COMPACT : ROW_STYLE} ${highlight ? "bg-yellow-100" : ""} ${
        Object.hasOwn(rest, "href") || Object.hasOwn(rest, "onClick")
          ? "hover:bg-gray-50"
          : ""
      }`,
      ...rest,
    },
    [
      <div className="relative top-[1px]" key="icon">
        <Icon {...(compact ? ICON_PROPS_COMPACT : ICON_PROPS)} />
      </div>,
      children,
    ],
  );
}
